let serial = 0;
const mounted = new WeakSet();
function enhance(root) {
  if (mounted.has(root)) return;
  mounted.add(root);
  const icons = (root.closest('.cl-form-card, .cl-form-section')?.querySelector('[data-cl-pfb-icons]') || root.querySelector('[data-cl-pfb-icons]'))?.content;
  const selects = new Map();
  const fileSizes = new Map();
  function formatSize(bytes) {
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  function rememberFiles(files) {
    Array.from(files || []).forEach(file => fileSizes.set(file.name, file.size));
  }
  function fieldFor(input) {
    return input.closest('.globo-form-control, .form-group, [class*="form-control"]');
  }
  function moveLabelOutside(input) {
    if (input.dataset.clLabelReady === 'true') return;
    const field = fieldFor(input);
    if (!field) return;
    let label = Array.from(input.labels || []).find(item => root.contains(item));
    if (!label) {
      label = Array.from(field.querySelectorAll('label, legend, .globo-label')).find(item => {
        if (item.closest('.cl-pfb-height-option')) return false;
        return !item.htmlFor || !input.id || item.htmlFor === input.id;
      });
    }
    if (!label) return;
    if (label.contains(input)) {
      if (!input.id) input.id = `cl-pfb-field-${++serial}`;
      const outside = document.createElement('label');
      outside.htmlFor = input.id;
      outside.textContent = label.textContent.trim();
      label.classList.add('cl-pfb-label-source');
      label = outside;
    }
    label.classList.add('cl-pfb-label-outside');
    field.prepend(label);
    input.dataset.clLabelReady = 'true';
  }
  function scan() {
    root.querySelectorAll('input:not([type=hidden]), textarea, select').forEach(input => {
      const type = input.type;
      if (type === 'checkbox') {
        const field = fieldFor(input);
        field?.classList.add('cl-pfb-consent-field');
        input.classList.add('cl-pfb-consent-input');
        const labels = Array.from(input.labels || []);
        if (!labels.length && field) labels.push(...field.querySelectorAll('label'));
        const inputFocusable = ['consent', 'acceptTerms'].includes(input.dataset.type) && input.matches('.cl-section.cl-form-section .checkbox-wrapper .checkbox-input');
        labels.forEach(label => {
          if (!root.contains(label)) return;
          label.classList.add('cl-pfb-consent-label');
          if (inputFocusable && label.tabIndex === 0) label.tabIndex = -1;
        });
        return;
      }
      if (['radio', 'file', 'submit', 'button'].includes(type)) return;
      moveLabelOutside(input);

      const field = fieldFor(input);
      if (input.matches('textarea')) {
        field?.classList.add('cl-pfb-design-field');
        input.classList.add('cl-pfb-design-input');
      }
    });
    root.querySelectorAll('select:not([multiple])').forEach(select => {
      if (selects.has(select) || select.size > 1) return;
      const shell = document.createElement('div');
      shell.className = 'cl-pfb-select';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'cl-pfb-select__trigger';
      trigger.setAttribute('role', 'combobox');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const value = document.createElement('span');
      trigger.append(value);
      const arrow = icons?.querySelector('[data-chevron]')?.cloneNode(true);
      if (arrow) trigger.append(arrow);
      const list = document.createElement('div');
      list.className = 'cl-pfb-select__list';
      list.id = `cl-pfb-options-${++serial}`;
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      trigger.setAttribute('aria-controls', list.id);
      const labels = Array.from(select.labels || []);
      if (labels.length) {
        labels.forEach(label => { if (!label.id) label.id = `cl-pfb-label-${++serial}`; });
        trigger.setAttribute('aria-labelledby', labels.map(label => label.id).join(' '));
      } else trigger.setAttribute('aria-label', select.getAttribute('aria-label') || select.name || 'Select');
      select.before(shell);
      shell.append(select, trigger, list);
      select.classList.add('cl-pfb-select__native');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      let active = -1;
      let signature = '';
      function close() {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('aria-activedescendant');
      }
      function highlight(index) {
        active = index;
        list.querySelectorAll('[role=option]').forEach((item, i) => item.classList.toggle('is-highlighted', i === active));
        const item = list.children[active];
        if (item) {
          trigger.setAttribute('aria-activedescendant', item.id);
          item.scrollIntoView({ block: 'nearest' });
        }
      }
      function sync() {
        const options = Array.from(select.options);
        const next = JSON.stringify(options.map(o => [o.text, o.value, o.disabled, o.hidden]));
        if (next !== signature) {
          signature = next;
          list.replaceChildren();
          options.forEach((option, index) => {
            const item = document.createElement('div');
            const isPlaceholder = index === 0 && (option.value === '' || option.disabled);
            item.id = `${list.id}-${index}`;
            item.setAttribute('role', 'option');
            item.textContent = option.text;
            item.hidden = option.hidden || isPlaceholder;
            item.setAttribute('aria-disabled', String(option.disabled || !!option.parentElement?.disabled));
            item.addEventListener('pointerdown', e => e.preventDefault());
            item.addEventListener('click', () => choose(index));
            list.append(item);
          });
        }
        value.textContent = options[select.selectedIndex]?.text || 'Please Select...';
        trigger.disabled = select.disabled;
        trigger.setAttribute('aria-required', String(select.required));
        trigger.setAttribute('aria-invalid', select.getAttribute('aria-invalid') || 'false');
        const described = select.getAttribute('aria-describedby');
        if (described) trigger.setAttribute('aria-describedby', described);
        list.querySelectorAll('[role=option]').forEach((item, i) => item.setAttribute('aria-selected', String(i === select.selectedIndex)));
      }
      function choose(index) {
        const option = select.options[index];
        if (!option || option.disabled || option.hidden || option.parentElement?.disabled) return;
        select.selectedIndex = index;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync(); close(); trigger.focus();
      }
      function open() {
        selects.forEach(state => state.close());
        sync(); list.hidden = false; trigger.setAttribute('aria-expanded', 'true');
        highlight(select.selectedIndex);
      }
      trigger.addEventListener('click', () => list.hidden ? open() : close());
      trigger.addEventListener('keydown', event => {
        if (event.key === 'Tab') return close();
        if (event.key === 'Escape') { if (!list.hidden) { event.preventDefault(); close(); } return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        if (list.hidden) { open(); return; }
        if (event.key === 'Enter' || event.key === ' ') return choose(active);
        const enabled = Array.from(select.options).map((o, i) => !o.disabled && !o.hidden && !o.parentElement?.disabled ? i : -1).filter(i => i >= 0);
        if (!enabled.length) return;
        let pos = enabled.indexOf(active);
        pos = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : Math.max(0, Math.min(enabled.length - 1, pos + (event.key === 'ArrowDown' ? 1 : -1)));
        highlight(enabled[pos]);
      });
      shell.addEventListener('focusout', e => { if (!shell.contains(e.relatedTarget)) close(); });
      select.addEventListener('change', sync);
      select.addEventListener('focus', () => trigger.focus());
      select.addEventListener('invalid', () => { trigger.setAttribute('aria-invalid', 'true'); trigger.focus(); });
      selects.set(select, { sync, close, shell });
      sync();
    });
    const heightGroups = new Map();
    root.querySelectorAll('input[type=radio]').forEach(input => {
      const label = Array.from(input.labels || []).find(l => root.contains(l));
      if (!label) return;
      const text = label.textContent.trim().toLowerCase().replace(/\s+/g, ' ');
      const key = /^(ankle|quarter|crew|knee(?: high)?)\*?$/.exec(text)?.[1]?.split(' ')[0];
      const source = key && icons?.querySelector(`[data-height="${key}"]`);
      if (!source) return;
      if (label.dataset.clHeightReady !== 'true') {
        const icon = source.cloneNode(true);
        icon.className = 'cl-pfb-height-icon';
        const name = document.createElement('span');
        name.className = 'cl-pfb-height-name';
        name.textContent = text.replace(/\*$/, '');
        label.replaceChildren(input, icon, name);
        label.dataset.clHeightReady = 'true';
      }
      label.classList.add('cl-pfb-height-option');
      input.classList.add('cl-pfb-height-input');
      const field = fieldFor(input);
      if (!field) return;
      field.classList.add('cl-pfb-height-field');
      if (!heightGroups.has(field)) heightGroups.set(field, []);
      heightGroups.get(field).push(label);
    });
    heightGroups.forEach((labels, field) => {
      let group = field.querySelector(':scope > .cl-pfb-height-options');
      if (!group) {
        group = document.createElement('div');
        group.className = 'cl-pfb-height-options';
        field.insertBefore(group, field.querySelector(':scope > .help-text, :scope > .messages'));
      }
      labels.forEach(label => group.append(label));
      const title = Array.from(field.querySelectorAll(':scope > label, :scope > legend, :scope > .globo-label')).find(label => !label.classList.contains('cl-pfb-height-option'));
      if (title) title.classList.add('cl-pfb-label-outside');
    });
    // The app's file list only shows names; sizes are captured when files are picked or dropped.
    root.querySelectorAll('.gfb__dropzone--preview--item-filename').forEach(name => {
      if (name.nextElementSibling?.classList.contains('cl-pfb-file-size')) return;
      const size = fileSizes.get(name.textContent.trim());
      if (size === undefined) return;
      const label = document.createElement('span');
      label.className = 'cl-pfb-file-size';
      label.textContent = formatSize(size);
      name.after(label);
    });
    root.querySelectorAll('.gfb__dropzone--placeholder--button').forEach(button => {
      if (button.textContent.trim() || button.getAttribute('aria-label')) return;
      const sources = [
        fieldFor(button)?.querySelector('.globo-label'),
        button.closest('.gfb__dropzone--placeholder')?.querySelector('.gfb__dropzone--placeholder--title'),
      ].filter(Boolean);
      if (!sources.length) return;
      sources.forEach(source => { if (!source.id) source.id = `cl-pfb-label-${++serial}`; });
      button.setAttribute('aria-labelledby', sources.map(source => source.id).join(' '));
    });
    root.querySelectorAll('.cl-pfb-height-option').forEach(label => {
      const input = Array.from(label.control ? [label.control] : label.querySelectorAll('input')).find(i => i.type === 'radio');
      label.classList.toggle('is-selected', !!input?.checked);
    });
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false; observer.disconnect();
      scan();
      selects.forEach((state, select) => root.contains(select) ? state.sync() : selects.delete(select));
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-invalid', 'aria-describedby', 'checked'] });
    });
  };
  const observer = new MutationObserver(schedule);
  root.addEventListener('change', event => { if (event.target.type === 'file') rememberFiles(event.target.files); }, true);
  root.addEventListener('drop', event => rememberFiles(event.dataTransfer?.files), true);
  root.addEventListener('change', schedule);
  root.addEventListener('cl:price', schedule);
  root.addEventListener('reset', () => setTimeout(schedule, 0));
  document.addEventListener('pointerdown', event => selects.forEach(state => { if (!state.shell.contains(event.target)) state.close(); }));
  schedule();
}
function init(scope = document) { scope.querySelectorAll('.cl-form-section .cl-pfb, cl-pricing-calculator').forEach(enhance); }
init();
document.addEventListener('shopify:section:load', event => init(event.target));
